module.exports = __webpack_public_path__ + "static/portfolio-mas-12-3d20ed8c04654c62637a0b35bfefdfb5.jpg";